/**
 * The optional features this backend has switched on.
 *
 * The backend sends them on the `user` object of every login and of
 * `/auth/me` (see `app_feature_flags` in backend/server.py), and AuthContext
 * hands them here as soon as it has them. Screens ask this module rather than
 * guessing from the shape of what a read endpoint happened to return.
 *
 * Everything defaults to OFF. A screen that renders before the user object
 * has landed therefore draws the plain, pre-feature version — never a half
 * feature — and the first render after sign-in has the real answer.
 */

const DEFAULTS = {
  // WP-GP — customer order grouping at Invoicing. PARKED, off by default,
  // until Callum decides Q25. Off means Misty invoices one job at a time,
  // exactly as it did before WP-GP was written.
  customer_order_grouping: false,
};

let current = { ...DEFAULTS };

/**
 * Store the switches that came back with the signed-in user.
 * Anything missing falls back to off.
 */
export const setFeatureFlags = (flags) => {
  current = { ...DEFAULTS };
  if (flags && typeof flags === 'object') {
    Object.keys(DEFAULTS).forEach((name) => {
      current[name] = flags[name] === true;
    });
  }
  return { ...current };
};

/** Forget them again — sign-out, and the start of a test. */
export const resetFeatureFlags = () => setFeatureFlags(null);

/** Every switch, as the backend last reported them. */
export const getFeatureFlags = () => ({ ...current });

/**
 * Is customer order grouping (WP-GP) switched on?
 *
 * Off: no customer order rows at Invoicing, no group invoice button, no
 * group picker, no consignment slip and no refusals.
 */
export const isCustomerOrderGroupingEnabled = () => current.customer_order_grouping === true;
